import ValidationStatusBadge from './ValidationStatusBadge';
import { formatDate } from '../../service/utils/formatters';

const ValidationList = ({ validations, currentUserAccountId }) => {

  return (
    <div className="card">
      <div className="card-header bg-light">
        <h6 className="mb-0">
          <i className="fas fa-person me-2"></i>
          Liste des Validateurs
        </h6>
      </div>
      <div className="card-body p-0">
        <div className="list-group list-group-flush">
          {validations.map((validation, index) => {
            const isCurrentUser = validation.validatedByAccountId === currentUserAccountId;
            
            return (
              <div key={validation.validationId} className="list-group-item">
                <div className="d-flex justify-content-between align-items-start">
                  <div className="flex-grow-1">
                    <div className="d-flex align-items-center mb-1">
                      <strong className="me-2">{validation.validatorName || 'Validateur en attente'}</strong>
                      {isCurrentUser && (
                        <span className="badge bg-primary bg-opacity-10 text-white border border-success rounded-pill border-opacity-25">
                          <i className="fas fa-person me-1"></i>
                          Vous
                        </span>
                      )}
                    </div>
                    
                    <div className="d-flex align-items-center flex-wrap gap-2">
                      <ValidationStatusBadge status={validation.status} size="small" />
                      
                      {validation.validatedUtc && (
                        <small className="text-muted">
                          <i className="fas fa-calendar me-1"></i>
                          {formatDate(validation.validatedUtc)}
                        </small>
                      )}
                    </div>

                    {validation.comments && (
                      <div className="mt-3">
                        <small className="text-muted fs-3 fw-bolder">
                          <strong>Commentaire:</strong> {validation.comments}
                        </small>
                      </div>
                    )}
                  </div>

                  <div className="text-end">
                    <small className="text-muted">
                      {/* #{validation.validationId} */}
                    </small>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ValidationList;